// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CityLinks-block-cZUt3 {
  --ink: #0f1214;
  --muted: #5a6168;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
}

.CityLinks-heading-QKJN8 {
  font-size: clamp(20px, 3vw, 26px);
  font-weight: 800;
  margin: 0 0 18px;
}

.CityLinks-grid-GILT1 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 8px 24px;
}

.CityLinks-svc-iaiDA {
  font-weight: 700;
  margin: 10px 0 6px;
  color: var(--ink);
}

.CityLinks-link-MUUaO {
  display: block;
  color: var(--muted);
  text-decoration: none;
  font-size: 13px;
  padding: 2px 0;
}

.CityLinks-link-MUUaO:hover {
  color: #e8232b;
  text-decoration: underline;
}

@media (prefers-color-scheme: dark) {
  .CityLinks-block-cZUt3,
  .CityLinks-heading-QKJN8,
  .CityLinks-svc-iaiDA {
    color: #f3f4f6;
  }
  .CityLinks-link-MUUaO {
    color: #9aa3ad;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/marketing/CityLinks.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;;;IAGE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".block {\n  --ink: #0f1214;\n  --muted: #5a6168;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n}\n\n.heading {\n  font-size: clamp(20px, 3vw, 26px);\n  font-weight: 800;\n  margin: 0 0 18px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 8px 24px;\n}\n\n.svc {\n  font-weight: 700;\n  margin: 10px 0 6px;\n  color: var(--ink);\n}\n\n.link {\n  display: block;\n  color: var(--muted);\n  text-decoration: none;\n  font-size: 13px;\n  padding: 2px 0;\n}\n.link:hover {\n  color: #e8232b;\n  text-decoration: underline;\n}\n\n@media (prefers-color-scheme: dark) {\n  .block,\n  .heading,\n  .svc {\n    color: #f3f4f6;\n  }\n  .link {\n    color: #9aa3ad;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `CityLinks-block-cZUt3`,
	"heading": `CityLinks-heading-QKJN8`,
	"grid": `CityLinks-grid-GILT1`,
	"svc": `CityLinks-svc-iaiDA`,
	"link": `CityLinks-link-MUUaO`
};
module.exports = ___CSS_LOADER_EXPORT___;
